import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Link, 
  Grid, 
  Divider,
  Stack
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1f1f21', // Dark grey for footer
        borderTop: '1px solid rgba(255,255,255,0.08)',
        mt: 'auto',
        py: { xs: 3, md: 4 }
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Brand Section */}
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#a187f2',
                fontWeight: 700,
                mb: 1
              }}
            >
              GrooveGate
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Share your music and get valuable feedback from other artists. 
              Connect with musicians worldwide and grow your sound.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <Link 
                component={RouterLink} 
                to="/" 
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Home
              </Link>
              <Link 
                component={RouterLink} 
                to="/register" 
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Sign Up
              </Link>
              <Link 
                component={RouterLink} 
                to="/login" 
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Sign In
              </Link>
              <Link 
                href="mailto:contact@groovegate.com"
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Contact
              </Link>
            </Stack>
          </Grid>

          {/* Legal Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Legal
            </Typography>
            <Stack spacing={1}>
              <Link 
                component={RouterLink} 
                to="/terms" 
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Terms of Service
              </Link>
              <Link 
                component={RouterLink} 
                to="/privacy" 
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Privacy Policy
              </Link>
              <Link 
                component={RouterLink} 
                to="/takedown" 
                color="text.secondary"
                sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
              >
                Notice & Takedown
              </Link>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.08)' }} />

        {/* Bottom Section */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'center', sm: 'flex-start' },
          gap: 2
        }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} GrooveGate. All rights reserved.
          </Typography>
          
          <Stack 
            direction="row" 
            spacing={3}
            sx={{ 
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', sm: 'flex-end' }
            }}
          >
            <Link 
              component={RouterLink} 
              to="/terms" 
              variant="body2"
              color="text.secondary"
              sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
            >
              Terms
            </Link>
            <Link 
              component={RouterLink} 
              to="/privacy" 
              variant="body2"
              color="text.secondary"
              sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
            >
              Privacy
            </Link>
            <Link 
              component={RouterLink} 
              to="/takedown" 
              variant="body2"
              color="text.secondary"
              sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
            >
              Takedown
            </Link>
            <Link 
              href="mailto:contact@groovegate.com"
              variant="body2"
              color="text.secondary"
              sx={{ textDecoration: 'none', '&:hover': { color: '#a187f2' } }}
            >
              Contact
            </Link>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
